module.exports = __webpack_public_path__ + "img/icon_map_all.9b689ddd.png";